import { controlType, deviceType } from "constant";

export const getGuardianState = (cars) => {
    const carList = Array.isArray(cars) ? cars : cars ? [cars] : [];

    let disabled = false;
    let checked = true;

    for (const car of carList) {
        const dev = car?.DevType;
        const ctl = car?.CarControlType;
        const isFT = ([deviceType.FT2]).includes(dev);
        const vdu3or4 = ([deviceType.VDU3, deviceType.VDU4]).includes(dev);

        const unsupported = (isFT && ctl === controlType.None) ||
            (vdu3or4 && ctl === controlType.Fusion && car?.BatteryLevel > 100);
        const supportsGuardian =
            ((isFT || vdu3or4) && (ctl === controlType.LIN || ctl === controlType.Fusion)) ||
            (vdu3or4 && ctl === controlType.GCCM);
        if ((supportsGuardian || unsupported) && car?.GuardianCapable === false) {
            checked = false;
            break;
        }
    }
    return { disabled, checked };
};